// @ts-nocheck
import React, { useEffect, useState } from 'react';

const MultilineInput = ({
    id,
    label,
    placeholder,
    required,
    onInputChange,
    value: initialValue,
}) => {
    const [value, setValue] = useState(String(initialValue ?? ''));
    useEffect(() => setValue(String(initialValue ?? '')), [initialValue]);
    const maxLength = 1000;
    const textareaId = `textarea-${id}`;

    const handleInputChange = (event) => {
        const newValue = event.target.value;
        setValue(newValue);
        onInputChange(label, newValue);
    };

    return (
        <div className="mb-6">
            <label
                htmlFor={textareaId}
                className="mb-2 block text-sm font-semibold text-slate-800"
            >
                <span data-i18n-ignore="true">{label}</span>
                {required && <span className="text-red-500">*</span>}
            </label>

            <textarea
                id={textareaId}
                maxLength={maxLength}
                className="min-h-32 max-h-72 w-full resize-y rounded-xl border border-slate-300 bg-slate-50/60 p-4 text-sm text-slate-900 shadow-sm outline-none transition hover:border-slate-400 focus:border-emerald-600 focus:bg-white focus:ring-4 focus:ring-emerald-100"
                placeholder={placeholder}
                data-i18n-ignore="true"
                onChange={handleInputChange}
                value={value}
                required={required}
            />

            <div className="mt-1.5 text-right text-xs font-medium text-slate-400">
                {value.length}/{maxLength}
            </div>
        </div>
    );
};

export default MultilineInput;
